// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__DS0RX","logo":"Navbar_logo__jA5Pb","links":"Navbar_links__GNnVc","link":"Navbar_link__61lqP","active":"Navbar_active__+dvfu","cta":"Navbar_cta__urCAZ"};